import { render, staticRenderFns } from "./HotelBuildingView.vue?vue&type=template&id=482f9590&"
import script from "./HotelBuildingView.vue?vue&type=script&lang=js&"
export * from "./HotelBuildingView.vue?vue&type=script&lang=js&"
import style0 from "./HotelBuildingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports